import { SharedUserProfile } from '@src/context/auth/types/SharedUserProfile';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';

export const isTenantMember = (profile?: SharedUserProfile): boolean => {
  if (!profile?.isTenant || !profile.tenantProfile?.user?.role) {
    return false;
  }

  return profile.tenantProfile.user.role.code === TENANT_ROLE.MEMBER;
};
